export default __webpack_public_path__ + "static/media/97_footer_quotation.b8e61f9b.png";